import React from 'react';
import CategoryController from "./controller/CategoryController";
import CustomOrder from "../customOrder/customOrder";
import MarketRepository from "../Main/repository/MarketRepository";
import BuyToolbar from "../Home/view/component/BuyToolbar/BuyToolbar";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

function CategoryError({productController}: {
    productController: CategoryController | null
}) {
    const {t} = useTranslation();
    const card = MarketRepository.getCartMarket();
    const {shopId} = useParams();

    return (
        <>
            <BuyToolbar/>
            <nav className={`category-container ${card.items.length ? 'active-buy-toolbar' : ''} category-failed-load`}>
                <span>{t("error.categoryLoadFailed")}</span>
                <button onClick={e => productController?.getCategories(shopId)}>{t("tryAgain")}</button>
                <CustomOrder/>
            </nav>
        </>
    );
}

export default CategoryError;